import { Component, Input } from '@angular/core';

import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-global-validation-message',
  templateUrl: './global-validation-message.component.html',
  styleUrls: ['./global-validation-message.component.css'],
  imports: [],
})
export class GlobalValidationMessageComponent {
  @Input() formInput: FormGroup | undefined = undefined;

  constructor() {
    console.log('GlobalValidationMessageComponent validation')
  }
}
